import React, { useContext, useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import { SRLWrapper } from "simple-react-lightbox";
import { SessionContext } from '../../common/SessionContext';

function BundlesDetailsTab(props) {
    const { session } = useContext(SessionContext);
    const bundles = Array.isArray(props.bundles) ? props.bundles : [];
    const [loading, setLoading] = useState(true);

    // Original gradient pairs
    const gradients = [
        ['#009FE3', '#E6007E'],
        ['#FBF299', '#E6007E'],
        ['#E6007E', '#E24259'],
        ['#E6007E', '#FBF299'],
        ['#6EBC86', '#009FE3'],
        ['#6EBC86', '#FBF299'],
    ];
    // Slightly richer but still subtle versions
    const paleGradients = [
        ['#70CFF4', '#F472AD'],  // richer than #B2E2F6 / #F7B2D8
        ['#FAE672', '#F472AD'],  // richer than #FDFBE0 / #F7B2D8
        ['#E64C9A', '#E77A76'],  // richer than #F7B2D8 / #F6C6CD
        ['#E64C9A', '#FAE672'],  // richer than #F7B2D8 / #FDFBE0
        ['#A0D1B0', '#70CFF4'],  // richer than #D3EADA / #B2E2F6
        ['#A0D1B0', '#FAE672'],  // richer than #D3EADA / #FDFBE0
    ];

    const bundleCards = bundles.map((bundle, idx) => {
        const [startColor, endColor] = paleGradients[idx % paleGradients.length];
        return (
            <div
                className="bundle-card"
                key={bundle.price_id}
                style={{
                    background: `linear-gradient(135deg, ${startColor}, ${endColor})`,
                    color: '#333',
                    borderRadius: '8px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                    padding: '1.5rem',
                    flex: '1 1 calc(33% - 1rem)',
                    boxSizing: 'border-box',
                }}
            >
                <div className="bundle-card-content">
                    <h4><strong>{bundle.use_limit} workshops</strong></h4>
                    <p>€{bundle.price} ({bundle.discount_percent}% discount)</p>
                    <form action="https://www.campfr.com/api/bundle_checkout" method="POST">
                        <input type="hidden" name="priceCode" value={bundle.price_id} />
                        <input type="hidden" name="ws" value={session.ws} />
                        <button
                            className="confirm-process-button"
                            type="submit"
                            style={{
                                backgroundColor: '#fff',
                                color: '#333',
                                border: 'none',
                                padding: '0.6rem 1.2rem',
                                borderRadius: '4px',
                                cursor: 'pointer'
                            }}
                        >
                            Buy now
                        </button>
                    </form>
                </div>
            </div>
        );
    });

    return (
        <div
            className="tab-pane fade show active package-info-tab"
            id="pill-body1"
            role="tabpanel"
            aria-labelledby="pills-package1"
        >
            <h3 className="d-subtitle has-bg-image">Study more, save up to 30%</h3>
            <div className="workshop_bodytext has-bg-image">
                <p>Immerse yourself in multiple CAMP online workshops, build a wide array of skills and knowledge, and save up to 30% with an Online Workshop bundle!</p>

                <p>We're holding over 100 online workshops in 2026/2027, in a variety of subjects including musical performance, composition, production, sound, ecoacoustics, literature & writing, visual arts, digital arts, performance art, activism and much more.</p>

                <p>You get:</p><br />

                <ul>
                    <li>A unique booking code - use it to enrol in multiple workshops</li>
                    <li>Early access to all online workshops, to make sure you never miss out</li>
                    <li>As a special bonus, your code can also be used as a 10% discount on any CAMP onsite workshop in 2026/27</li>
                </ul>

                <p>Choose your bundle package below - please note that bundles can't be applied retrospectively, make sure you buy your bundle <b>before you book a course place</b>, then use your bundle code when you reserve your place.</p>

                <div className="bundle-prices">
                    <div
                        className="bundles-cards"
                        style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem' }}
                    >
                        {bundleCards}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default BundlesDetailsTab;
